import Vue from 'vue'
// import './utils/debug-console'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import { loadExtension } from '@/extension/extension-loader'

import i18n from '@/libs/i18n'
import VueMoment from 'vue-moment'
import VueLazyLoad from 'vue-lazyload'
import ElementUI from 'element-ui'
import elementTh from 'element-ui/lib/locale/lang/th'
import elementLocale from 'element-ui/lib/locale'
import Vant from 'vant'
import router from './router'
import store from './store'
import App from './App.vue'
import 'vant/lib/index.css'
import './icons'
import '@/iconfont/iconfont.css'
import './utils/directive'

// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme-line/index.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

import 'leaflet/dist/leaflet.css'

import '@vant/touch-emulator'

Vue.use(Vant)

loadExtension()

elementLocale.use(elementTh)
Vue.use(ElementUI, { size: 'small' })

Vue.use(VueLazyLoad)

Vue.use(VueMoment)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
